import { Component, Input } from '@angular/core';

import { Observable } from 'rxjs';
import { ICustomer } from 'app/models';

@Component({
  selector: 'app-customer-component',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
})
export class CustomerComponent {
  @Input()
  customer$: Observable<ICustomer> | null = null;
}
